<template>
    <div class="vant-card">
        <div class="dataFrom">
            <van-field v-model="checked"  name="radio"  label="提现方式">
                <template #input>
                    <van-radio-group v-model="checked" direction="horizontal" @change="changePayType">
                        <van-radio name="1">支付宝</van-radio>
                        <van-radio name="8">收款码</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field name="img"  label="收款码" v-if="checked === '8'">
                <template #input>
                    <img :src="'http://czlj.wzyw.cc:8888/' + scanData.scanImg" alt="" style="width: 60px;height: 60px;">
                </template>
            </van-field>
            <van-cell-group v-if="checked === '1'">
                <van-field v-model="dataFrom.wxPhone" type="tel" label="收款账户" placeholder="请输入支付宝账户" />
            </van-cell-group>
             <van-cell-group v-if="checked === '1'">
                <van-field v-model="dataFrom.backName"  label="姓名" placeholder="请输入收款人姓名" />
            </van-cell-group>
        </div>
        <div class="content">
            <div class="widthdr">提现金额</div>
            <van-cell-group>
                <van-field v-model="dataFrom.priceRmb" label="¥" :placeholder="'可返现金额 ' + accountData" type="number"/>
            </van-cell-group>
            <div class="widthdr">提现密码</div>
            <van-cell-group>
                <van-field class="account" v-model="dataFrom.paypass" label="" placeholder="请输入提现密码" type="password"  />
            </van-cell-group>
            <div class="small">最小提现金额{{configData.cashoutMinAmount}}元，小于100 额外扣除1元 单笔手续费百分之{{configData.cashoutFee}}</div>
            <mt-button type="primary" size="large" @click="sumbit">提现</mt-button>
            <mt-button type="primary" size="large" @click="show=true">设置提现收款码</mt-button>
            <mt-button type="primary" size="large" @click="sumbitCose" class="vant-close">取消</mt-button>
        </div>
        <van-dialog v-model:show="show" title="修改提现收款二维码" show-cancel-button @confirm="confirm" :width="340" :closeOnPopstate="false" :beforeClose="beforeClose" @cancel="cancel">
            <van-field name="uploader" label="文件上传">
                <template #input>
                  <van-uploader v-model="file" :max-count="1" :before-read="beforeRead"/>
                </template>
              </van-field>
            <van-field v-model="setChecked"  name="radio"  label="收款码类型">
                <template #input>
                    <van-radio-group v-model="setChecked" direction="horizontal">
                        <van-radio name="1">支付宝</van-radio>
                        <van-radio name="0">微信二维码</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
        </van-dialog>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { wxRequest} from '@/api/agent.js'
export default {
    name:'card',
    data(){
        return{
            configData:{},
            dataFrom:{ },
            accountData:'',
            file:[],
            checked:'1',
            setChecked:'1',
            show:false,
            scanFlg: false,
            scanData: {
                scanImg: '',
                scanType: '',
            }
        }
    },
    created(){
        this.config()
        this.accountList()
    },
    methods:{
       
        changePayType() {
            if (this.checked == '8') {
                wxRequest('agent/select/agent/scan', {}, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.scanData.scanImg = res.data.data.scanImg;
                        if (!res.data.data.scanImg) {
                            Toast('请点击下方按钮设置收款码后，再选择收款码提现！');
                            return;
                        }
                    }
                })


            }
        },
        beforeRead (file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                Toast('请上传 jpg / png 格式图片');
                return false;
            }
            return true;
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                done(false);
                if(this.file.length === 0){
                    Toast('请上传收款二维码');
                    return false;
                }
                let fd = new FormData();
                fd.append('scanType', this.setChecked);
                fd.append("scanTitle", this.file[0].file);
                wxRequest("agent/insert/agent/scan", fd, "post").then((res) => {
                    if (res.data.code === '200') {
                        Toast(res.data.message);
                        this.setChecked = '1'
                        this.file = []
                        this.show = false
                    } else {
                        Toast(res.data.message);
                    }
                })
            } else {
                done();
            }
        },
        cancel(){
            this.file = []
        },
        confirm(){
           
        },
        // 获取最小值
        config(){
            wxRequest('agent/account/cashout/config', {}, 'post').then(res => {
                if(res.data.code === '200'){
                    this.configData = res.data.data
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        //查询账户信息
        accountList(){
            wxRequest('agent/account/list', {}, 'post').then(res => {
                if(res.data.code === '200'){
                   if(Array.isArray(res.data.data.resultList) && res.data.data.resultList.length>0){
                        res.data.data.resultList.forEach(element => {
                            if(element.type===10){
                               this.accountData = element.balanceRmb
                            }
                        });
                   }
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        //提现
        sumbit(){
            if(this.dataFrom.priceRmb> this.accountData ){
                Toast('提现金额不能大于可提现金额，请重新输入')
                return
            }
            if(this.dataFrom.priceRmb < this.configData.cashoutMinAmount ){
                Toast('提现金额不能小于最小提现金额，请重新输入')
                return
            }
            this.dataFrom.cashType=this.checked;
            wxRequest('agent//account/cashout/apply/wx',this.dataFrom, 'post').then(res => {
                if(res.data.code === '200'){
                   this.$messagebox.alert(res.data.message)
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        //取消提现
        sumbitCose(){},
    }
}
</script>
<style lang="less" scoped>
    .vant-card{
        height:100%;
        background: #F5F5F5;
        padding-top: 10px;
        .dataFrom{
            margin:0px 14px 16px 14px;
            padding:8px;
            [class*=van-hairline]::after{
                border:0
            }
            .van-cell{
                background: #F5F5F5;
                padding: 16px 0;
                border-bottom: 1px solid #ECECEC;
                :not(:last-child)::after{
                     border:0
                }
            }
            .van-cell-group{
                /deep/.van-cell__title{
                    color:#000;
                }
                /deep/.van-cell__value{
                    .van-field__control{
                        line-height: 24px;
                    }
                }
            }
        }
        .content{
            background:#fff;
            margin:21px 12px 0;
            padding-bottom:20px;
            [class*=van-hairline]::after{
                border:0
            }
            .widthdr{
                font-size:14px;
                color:#000;
                padding-left: 24px;
                padding-top:24px;
                padding-bottom:19px;
            }
            .van-cell{
                border-bottom: 1px solid #F5F5F5;
                margin-left:24px;
                margin-right:24px;
                width: calc(100% - 48px);
                padding-left: 0;
                /deep/.van-cell__title{
                    width:20px;
                    color:#000;
                    font-size:26px;
                }
                /deep/.van-cell__value{
                    .van-field__control{
                        line-height: 26px;
                        padding-left: 6px;
                        font-size: 16px;
                    }
                }
            }
            .account{
                /deep/.van-cell__title{
                   display: none;
                }
                /deep/.van-cell__value{
                    .van-field__control{
                        padding-left: 0;
                    }
                }
            }
            .small{
                font-size:13px;
                color: #999;
                margin-bottom:32px;
                margin-top:12px;
                padding-left:21px;
            }
        }
        button{
            margin: 16px 14px 0 14px;
            width: calc(100% - 28px);
            font-size:14px;
            background:#1677FE;
            border-radius:8px;
            height:48px;
        }
        .vant-close{
            background:#fff;
            color: #999;
        }
    }
</style>